import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_INTEGRATION_GEO_DATA',
  name: 'Workspace Project Geo Data Integration',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY', 'RESTORE'],
}

export default scope
